import React, {Component} from 'react';
import {Container, Header} from "semantic-ui-react";
import Footer from "./footer";
import {withRouter} from "react-router-dom";
import {connect} from "react-redux";
import {CustomGrid, S3Image} from "./custom-common";
import IMAGE from "../constants/images";
import {STRATEGIC_PARTNER} from "../constants/strategicPartners";

const mapStateToProps = (state, ownProps) => {
    const {initialData} = state;
    return {
        ...ownProps,
        email: initialData.email,
    }
};

class UnsubscribeSuccess extends Component {
    constructor(props) {
        super(props);
        window.onbeforeunload = null;
    }

    render() {
        const {email} = this.props;
        return (
            <React.Fragment>
                <Container>
                    <CustomGrid container stackable columns={1}  textAlign={'center'} >
                        <CustomGrid.Column style={{maxWidth: '420px'}}>
                            <S3Image {...IMAGE.CHECK}/>
                            <Header as='h2'>Unsubscribe successful</Header>
                            <p>{email} will no longer receive marketing emails from {STRATEGIC_PARTNER.LABEL}.</p>
                        </CustomGrid.Column>
                    </CustomGrid>
                </Container>
                <Footer showTopFooter={false} showCenterData={true}/>
            </React.Fragment>
        );
    }
}

export default withRouter(connect(mapStateToProps)(UnsubscribeSuccess));